import React, { useContext, useEffect, useState } from 'react'
import { Helmet } from "react-helmet";
import { useNavigate } from 'react-router-dom';
import useProfileStore from 'services/store/ProfileModule';
import useTranslations from 'i18n/useTranslations';
import PageLoader from 'components/loader/LoaderPage';
import ModalContext from 'contexts/ModalContext';
import { GetCustomerProfile } from 'services/Api/Module/Customer';
import { useLiff } from "react-liff";
import { GetBrandIdByName } from 'services/Api/Module/Brand';
import { useSearchParams } from 'react-router-dom';

const LineDeepLink = () => {
    const { isLoggedIn, isReady, liff } = useLiff()
    let [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const { lang, supportedLangs, setLang } = useTranslations(); // สำหรับเปลี่ยนภาษา
    const { t } = useTranslations();
    const lineProfile = useProfileStore()
    const { mAlert } = useContext(ModalContext);

    const qPage = searchParams.get("page")
    const qRestaurantName = searchParams.get("restaurantName")

    const [registerStatus, setRegisterStatus] = useState(0)

    const fetchGetProfile = async (payload) => {
        try {
            const response = await GetCustomerProfile({ params: payload });
            const resData = response?.data.resultData;
            // const redirect =`/${qPage}?restaurantId=${}`
            if (response?.data.resultCode == '20000') {
                if (resData.id && resData.isregisSbSystem  == 1){
                    setRegisterStatus(1)
                } else {
                    setRegisterStatus(2)
                }
            } else {
                setRegisterStatus(2)
            }

        } catch (err) {
            console.log('err ', err);
            mAlert.info({
                title: "แจ้งเตือน",
                subTitle: "มีบางอย่างผิดพลาด",
                content: "",
                onClose: () => { },
            });
        }
    };

    const fetchRestaurantNameId = async (payload) => {
        try {
            const response = await GetBrandIdByName({ params: payload });
            const resData = response?.data.resultData;
            console.log('fetchGetProfile >>', response.data)
            if (resData.length) {
                if(registerStatus === 1) {
                    const redirectPage =`/${qPage}?restaurantId=${resData[0].id}`
                    navigate(redirectPage)
                }
                else if (registerStatus === 2) {
                    const query =`?page=${qPage}&restaurantId=${resData[0].id}`
                    navigate(`/welcome` + query)
                }
            } else {
                mAlert.info({
                    title: "แจ้งเตือน",
                    subTitle: "ไม่พบข้อมูล",
                    content: "",
                    onClose: () => { },
                });
            }
            

        } catch (err) {
            console.log('err ', err);
            mAlert.info({
                title: "แจ้งเตือน",
                subTitle: "มีบางอย่างผิดพลาด",
                content: "",
                onClose: () => { },
            });
        }
    };

    const getLineData = async () => {
        const profile = await liff.getProfile();
        const payload = {
            lineUid: profile.userId,
            check: '0'
        };
        fetchGetProfile(payload)
    }

    useEffect(() => {
        if (registerStatus) {
            const payload = {
                restaurantName: qRestaurantName,
            };
            fetchRestaurantNameId(payload)
        }
        
    }, [registerStatus]);

    

    useEffect(() => {
        getLineData()
    }, []);
    return <PageLoader/>
}

export default LineDeepLink